import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  getMessages,
  type GetMessagesParams,
  type GetMessagesResponse,
} from '@services/MatchesService';

export type UseGetMessagesParams = {
  matchId: string;
  mutationOptions?: SWRMutationConfiguration<
    GetMessagesResponse,
    unknown,
    string,
    GetMessagesParams,
    GetMessagesResponse
  >;
};

export const getMessagesMutationKey = (matchId: string) =>
  `get-messages-${matchId}`;

export const useGetMessages = ({
  matchId,
  mutationOptions,
}: UseGetMessagesParams) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    GetMessagesResponse,
    unknown,
    string,
    GetMessagesParams
  >(
    getMessagesMutationKey(matchId),
    (_url, { arg }) =>
      getMessages({
        matchId,
        queryParams: arg,
      }),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
